module.exports = __webpack_public_path__ + "img/wheel_tyre_logo.c3aeafc5.png";